module.exports = __webpack_public_path__ + "static/img/patient_management_gray.79af93b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/patient_management_gray.png
// module id = JJ89
// module chunks = 1